import * as R from 'ramda';
/** postGetMemberImage :: string ->  Promise(Either) */
import { postJSONPS } from '../../../lib/utils/fetch';
import { either } from '../../../lib/utils/utils';
const postGetMemberImage = R.curry(imagePath =>
	postJSONPS('POST', '/member/image', {
		body: JSON.stringify({ imagePath })
	})
);

const getImage = (imageURL, updateImageURL, data) => {
	const { memImage } = data;
	if (memImage) {
		postGetMemberImage(memImage).then(
			either(
				e => updateImageURL('noimage'),
				response => {
					R.compose(
						R.tap(imageURL => updateImageURL(imageURL)),
						blob => window.URL.createObjectURL(blob),
						R.tap(() => {
							window.URL.revokeObjectURL(imageURL);
						}),
						data =>
							new Blob([new Uint8Array(data)], {
								type: 'image/jpeg'
							}),
						R.prop('data')
					)(response);
				}
			)
		);
	} else {
		updateImageURL('noimage');
	}
};

export { getImage };
